/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S2_BodyInputs */

const en_landing_guide_s2_body = /** @type {(inputs: Landing_Guide_S2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drift is the slow damage that piles up when a model redraws a whole image to change one detail. The model reduces it by treating the edit as a local change. In this workspace you make that explicit: paint a mask over the area to change and describe the edit. It then rewrites only the painted region, and Pixel Lock then copies every unpainted pixel straight back from your source. Depending on the size of the mask, 94-99% of the image comes back bit-for-bit identical, pass after pass, so the tenth edit looks as clean as the first.`)
};

const zh_landing_guide_s2_body = /** @type {(inputs: Landing_Guide_S2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`漂移，是模型为了改一个细节而重绘整张图时，不断累积的细微损伤。Ideogram 4.5 把编辑当作局部修改来处理，从而减少漂移。在本工作台里，你可以把这一点做得更明确：涂抹要修改的区域并描述修改。Ideogram AI 4.5 只重写涂抹区域，随后像素锁定把所有未涂抹的像素从原图逐个拷回。根据涂抹面积不同，画面 94%-99% 的部分逐位完全一致，一轮又一轮，第十次编辑依然和第一次一样干净。`)
};

/**
* | output |
* | --- |
* | "Drift is the slow damage that piles up when a model redraws a whole image to change one detail. The model reduces it by treating the edit as a local change. ..." |
*
* @param {Landing_Guide_S2_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s2_body = /** @type {((inputs?: Landing_Guide_S2_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S2_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s2_body(inputs)
	return zh_landing_guide_s2_body(inputs)
});
export { landing_guide_s2_body as "landing.guide.s2_body" }